export default "__VITE_ASSET__DyU6kZuQ__"